import moment from "moment";
import { DATE_FORMAT_DD_MM_YYYY } from "../../../utils/consts";

export const parseDate = (d?: string) => {
    if (!d) return null;
    return moment(d, DATE_FORMAT_DD_MM_YYYY, true);
};